import { useTranslation } from "@outschool/localization";
import { Label } from "@outschool/ui-legacy-component-library";
import { SystemStyleObject } from "@styled-system/css";
import React from "react";

export function LearnerBlockedBadge({ sx = {} }: { sx?: SystemStyleObject }) {
  const { t } = useTranslation(
    "client\\components\\teacher\\LearnerBlockedBadge",
  );
  return (
    <Label
      color="redhot200"
      textColor="redhot700"
      sx={{ fontWeight: "semibold", ...sx }}
    >
      {t("Blocked")}
    </Label>
  );
}
